import {Component, OnInit, EventEmitter} from '@angular/core';
import {FinanceBaseComponent} from '../../shared/components/finance-base-component/finance-base.component';
import {Jurisdiction} from '../../../foundation/models/enums/jurisdiction.enum';

@Component({
    selector: 'disbursement-request-confirmation',
    templateUrl: './disbursement-request-confirmation.html',
    outputs: ['backEvent'],
    inputs: ['disbursementRequestId', 'customerAccountDetail', 'newAccountBalance', 'displayName']
})

export class DisbursementRequestConfirmationComponent extends FinanceBaseComponent implements OnInit {

    // Gets or sets the disbursement request id
    public disbursementRequestId: number;

    // Gets or sets the customer account detail
    public customerAccountDetail: any;

    // Gets or sets the display name
    public displayName: string;

    // Gets or sets the new account balance
    public newAccountBalance: number;

    // Gets or sets the back event emitter
    public backEvent: EventEmitter<any> = new EventEmitter<any>();

    // Gets or sets the jurisdiction
    public states = new Jurisdiction();

    /**
     * @param router
     * @param route
     */
    constructor() {
        super();
    }

    /**
      * Initializes component
      */
    public ngOnInit() {

        this.initPageData();
    }

    /**
     * Initializes the required page data
     */
    protected initPageData() {

    }

    /**
     *
     * @param data
     */
    protected setPageData(data: any) {
    }

    /**
     * Handles the navigate back event
     */
    public navigateBack() {
        this.backEvent.emit();
    }

    /**
     * Handles the cancel event
     */
    protected cancel() {
        this.backEvent.emit();
    }

    /**
     * Gets the value from the passed in data
     */
    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }

}
